/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Logic from 'fierry/data/logic';

import { areEqual } from 'fierry/type/compare';

import HexGroup from 'solis/type/hex/group';

import BoardZone from 'solis/react/board/data/board.zone';

import FinalizeBoard from 'solis/claude/projection/finalize.board';


export default class extends Logic
{
  constructor ({ board, sourceColony = null })
  {
    super(board);

    this.sourceColony = sourceColony;

    this.mutate(FinalizeBoard);
  }


  getCenterDisplayHex ()
  {
    // QQ Right now, when colony is already visible this places board off center and it looks bad.
    /*if (this.sourceColony !== null)
    {
      const zones = this.sourceColony.getSectors().flatMap(sector => sector.getZones().values());

      return new HexGroup(zones.map(zone => zone.getAbsoluteHex())).getCenter();
    }*/

    return new HexGroup(this.object.getZones().keys()).getCenter();
  }


  getZone (displayHex)
  {
    const zone = this.object.getZone(displayHex);

    return zone !== null ? new BoardZone(zone, this) : null;
  }


  getZones ()
  {
    return this.object.getZones().values().map(zone => new BoardZone(zone, this));
  }


  getSelectableZone (displayHex)
  {
    return this.getZone(displayHex);
  }


  toEntityHex (displayHex)
  {
    return displayHex;
  }


  toDisplayHex (entityHex)
  {
    return entityHex;
  }


  equals (other)
  {
    return super.equals(other) && areEqual(this.sourceColony, other.sourceColony);
  }

};
